module.exports = __webpack_public_path__ + "img/composer-rate.2add0231.svg";